import React from 'react';

import { Button, CircularProgress } from '@mui/material';
import { AlertTriangle, Inbox, RotateCcw } from 'lucide-react';

import styles from './StateView.module.scss';

export const Loader = ({ label }: { label?: string }) => (
    <div className={styles.state} role='status'>
        <CircularProgress size={36} color='secondary' />
        {label && <p className={styles.text}>{label}</p>}
    </div>
);

type ErrorStateProps = {
    message?: string;
    onRetry?: () => unknown;
};

export const ErrorState = ({
    message = 'Не удалось загрузить данные',
    onRetry,
}: ErrorStateProps) => (
    <div className={styles.state} role='alert'>
        <AlertTriangle
            className={styles.errorIcon}
            size={36}
            strokeWidth={1.5}
        />
        <p className={styles.text}>{message}</p>
        {onRetry && (
            <Button
                onClick={onRetry}
                startIcon={<RotateCcw size={16} />}
                variant='outlined'
                color='inherit'
            >
                Повторить
            </Button>
        )}
    </div>
);

type EmptyStateProps = {
    icon?: React.ReactNode;
    title: string;
    description?: React.ReactNode;
    action?: React.ReactNode;
};

export const EmptyState = ({
    icon = <Inbox size={36} strokeWidth={1.5} />,
    title,
    description,
    action,
}: EmptyStateProps) => (
    <div className={styles.state}>
        <div className={styles.emptyIcon}>{icon}</div>
        <p className={styles.title}>{title}</p>
        {description && <p className={styles.text}>{description}</p>}
        {action}
    </div>
);
